import React from "react";
import { Banner } from "../Banner";
import DemographicsNotification from "./DemographicsNotification";
import Physician from "../../../Physician/Models/Physician";
import SystemNotifications, { SystemNotificationButtonAction } from "./SystemNotifications";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../Auth/AuthProvider";
import SystemNotificationService from "../../../../Services/Notifications/SystemNotificationService";
import SystemNotification, { SystemNotificationDisplayType } from "../../../Notifications/Models/SystemNotification";
import { deepCopy } from "../../Utility/DeepCopy";
import { useHistory } from "react-router-dom";
import { ProfileContext } from "../../../Auth/ProfileProvider";
import { abpnClient } from "../../../../Services/AbpnClient";
import DemographicPromptResponseModel from "../../../Account/Models/DemographicPromptResponseModel";
import isNullOrUndefined from "../../Utility/isNullOrUndefined";
import {isAbsoluteUrl, canNavigateToUrl} from "../../Utility/urlUtil";

interface IProps { 
    physician : Physician;    
}

export default function NotificationManager(props : IProps) {
    const authContext = useContext(AuthContext);
    const { user } = useContext(ProfileContext);
    const [notifications, setNotifications] = useState<SystemNotification[]>([]);
    const history = useHistory();
    
    const [showDemographicsModal, setShowDemographicsModal] = useState<boolean | null>(null);
    const [demographicPromptResponse, setDemographicPromptResponse] = useState<DemographicPromptResponseModel>(null);

    const navigateToPrimaryActionUrl = (primaryActionUrl : string) => {
        if (isNullOrUndefined(primaryActionUrl) || primaryActionUrl.trim().length == 0) return;

        if (isAbsoluteUrl(primaryActionUrl))
        {
            if (canNavigateToUrl(primaryActionUrl))
            {
                window.location.replace(primaryActionUrl);
            }
        }
        else 
        {
            history.push(new URL(primaryActionUrl, document.location.origin).pathname);
        }

    }

    useEffect(() => {
        const loadDemographicPromptResponse = async (physicianResult: Physician) => {
            let promptResponseResult = await abpnClient.get<DemographicPromptResponseModel>(`/api/physicianDemographic/GetDemographicPromptResponse`,authContext);
            if(promptResponseResult == null){
                promptResponseResult = new DemographicPromptResponseModel();
                promptResponseResult.personKey = physicianResult.physicianId;
            }
            setDemographicPromptResponse(promptResponseResult);
            setShowDemographicsModal(!(promptResponseResult.primaryActionTaken === true || promptResponseResult.permanentlyDismiss === true))
        }

        if (props.physician != null) loadDemographicPromptResponse(props.physician);

    }, [user, props.physician]);

    useEffect(() => {
        if (showDemographicsModal == null) return //Wait until demographic notification is loaded to load other notifications
       
        async function getActiveSystemNotifications() {
            const response = await SystemNotificationService.getSystemNotifications(authContext);
            setNotifications(response);
        }

        getActiveSystemNotifications();

    }, [showDemographicsModal]);

    const onNotificationAction = async (notificationActionType : SystemNotificationButtonAction, notification: SystemNotification) => {
        //Remove the banner notification
        if (notification.displayType == SystemNotificationDisplayType.Banner){
            const notificationsCopy = deepCopy(notifications);
            notificationsCopy.splice(notifications.findIndex(n => n.systemNotificationId==notification.systemNotificationId),1);
            setNotifications(notificationsCopy);
        }

        switch (notificationActionType){
            case SystemNotificationButtonAction.PrimaryAction: {
                await SystemNotificationService.saveSystemNotificationResponse({personKey: props.physician.physicianId, primaryActionTaken: true, permanentlyDismiss: false, systemNotificationId: notification.systemNotificationId}, authContext);
                if (notification.primaryActionUrl) navigateToPrimaryActionUrl(notification.primaryActionUrl);
                break;
            }
            case SystemNotificationButtonAction.DontRemindMeAction: {
                await SystemNotificationService.saveSystemNotificationResponse({personKey: props.physician.physicianId, primaryActionTaken: false, permanentlyDismiss: true, systemNotificationId: notification.systemNotificationId}, authContext);
                break;
            }
            default:
            case SystemNotificationButtonAction.CloseAction: {
                break;
            }
        }
    }


    return (<SystemNotifications notifications={notifications} onNotificationAction={onNotificationAction} showModalNotifications={showDemographicsModal === false}>
        <DemographicsNotification physician={props.physician} showDemographicsModal={showDemographicsModal} setShowDemographicsModal={setShowDemographicsModal} demographicPromptResponse={demographicPromptResponse} setDemographicPromptResponse={setDemographicPromptResponse}/>
        <Banner></Banner>
    </SystemNotifications>);
}